// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3jkjQ","bigColWidth":"Table_bigColWidth__2AG0k","biggerColWidth":"Table_biggerColWidth__2Fg7v","row":"Table_row__3Cjy2","col":"Table_col__3ZSaV"};